<script>
export let resource = 'archive';
export let name = 'este compositor';
</script>

<h3 class="text-center text-2xl text-red-600">
    Aún not tenemos {resource} de {name}.
    <span class="block text-base text-gray-800 py-4">Por favor mandenos un mensaje si le gustaría contribuir.</span>
</h3>